import {Injectable} from '@angular/core';
import {Action, Select, Selector, State, StateContext, StateToken} from '@ngxs/store';
import {throwError} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {Order} from "../models/order.model";
import {CreateOrderAction, GetOrderAction, GetOrderListAction, ResetOrderListFilter, SearchOrderListAction} from '../actions/order.actions';
import {OrderApiService} from "../api/order.api.service";
import {Constants} from "../util/constants";
import {OrderListFilter} from "../models/order-list-filter.model";
import {PageableApiResult} from "../models/pagable-api-result.model";
import {DateFilter} from "../models/date-filter.model";
import {DateTime} from "luxon";

export interface OrderStateModel {
  orderList: Order[],
  order: Order,
  orderListFilter: OrderListFilter,
  orderPage: PageableApiResult<Order>,
}

const initialState: OrderStateModel = {
  orderList: null,
  order: null,
  orderListFilter:null,
  orderPage:null
};

const ORDER_STATE_TOKEN = new StateToken<OrderStateModel>('order');

@State<OrderStateModel>({
  name: ORDER_STATE_TOKEN,
  defaults: initialState
})
@Injectable()
export class OrderState {

  constructor(
    private orderApiService: OrderApiService
  ) {
  }

  @Action(GetOrderListAction)
  handleGetOrderListAction(ctx: StateContext<OrderStateModel>, action: GetOrderListAction) {

    ctx.patchState({
      orderList: null
    })

    return this.orderApiService.getOrderList().pipe(
      tap(orderList => {
        const state = ctx.getState();

        ctx.patchState({
          orderList
        })

      }),
      catchError(err => {
        return throwError(err)
      })
    );
  }

  @Action(GetOrderAction)
  handleGetOrderAction(ctx: StateContext<OrderStateModel>, action: GetOrderAction) {

    const {orderId} = action.payload;


    return this.orderApiService.getOrder(orderId).pipe(
      tap(order => {
        const state = ctx.getState();

        ctx.patchState({
          order
        })

      }),
      catchError(err => {
        return throwError(err)
      })
    );
  }

  @Action(CreateOrderAction)
  handleCreateOrderAction(ctx: StateContext<OrderStateModel>, action:CreateOrderAction) {

    const {importe, userReceiverId, password} = action.payload;

    ctx.patchState({
      order:null
    })

    return this.orderApiService.createOrder(importe, userReceiverId, password).pipe(
      tap(createdOrder => {
        const state = ctx.getState();

        // ctx.patchState({
        //   order:createdOrder,
        //   bankList:[state.bankList,createdBank]
        // })

      }),
      catchError(err => {
        return throwError(err)
      })
    );

  }

  @Action(SearchOrderListAction)
  handleSearchOrderListAction(ctx: StateContext<OrderStateModel>, action: SearchOrderListAction) {
    // Check for status options in state
    const filter = ctx.getState()?.orderListFilter;
    const actionFilter = action.payload?.filter
    const defaultDateFilter:DateFilter = {
      from:DateTime.fromObject({day:1,month:1,year:2022}).toJSDate().toISOString()
    }

    let reqFilter: OrderListFilter

    if (filter) {
      reqFilter = {
        ...filter,
        ...actionFilter
      }

    } else {
      //filtros por defecto:
      reqFilter = {
        page: 0,
        size: Constants.PAGE_SIZE,
        dateFilter: (actionFilter?.dateFilter)||defaultDateFilter
      }
    }

    ctx.patchState({
      orderListFilter: reqFilter
    })
    return this.orderApiService.searchOrderList(reqFilter).pipe(
      tap(orderPage => {
        ctx.patchState({
          orderPage
        })
      })
    )
  }

  @Action(ResetOrderListFilter)
  handleResetOrderListFilter(ctx: StateContext<OrderStateModel>): void {
    ctx.patchState({
      orderListFilter: {
        dateFilter : {
          from: DateTime.fromObject({day:1,month:1,year:2022}).toJSDate().toISOString(),
          to: '',
        },
      }
    });
  }

  @Selector()
  static getOrderList(state: OrderStateModel): Order[] {
    return state?.orderList
  }

  @Selector()
  static getOrder(state: OrderStateModel) {
    return state?.order
  }

  @Selector()
  static getOrderPage(state: OrderStateModel): PageableApiResult<Order> {
    return state?.orderPage
  }
  @Selector()
  static getOrderListFilter(state: OrderStateModel): OrderListFilter{
    return state?.orderListFilter;
  }
}
